// select the correct language here
import language from "./../../src/common/i18n/de_de.json";

const dictionary = language;
// if needed change some strings here or add some

dictionary.Promospot = "Beilagen";
dictionary.HorsSeries = "Extra";
dictionary.Archive = "Ältere Ausgaben";

dictionary.regions = "Lokalausgaben";
dictionary.region = "Lokalausgaben";
dictionary.ReadingPreference = "Darstellung";
dictionary.readingModeToggle = "Darstellung";
dictionary.LogIn = "Anmelden";
dictionary.LogInWith = "Anmelden mit:";
dictionary.about = "Weitere Informationen";
dictionary.dataPolicy = "Impressum";
dictionary.disclaimer = "Allgemeine Geschäftsbedingungen";
dictionary.account = "Anmelden";
dictionary.privacyPolicy = "Datenschutzerklärung";
dictionary.alsoRead = "Link zum Werbetreibenden";
dictionary.Extra = "Noch mehr Inhalte";

export default dictionary;



// WEBPACK FOOTER //
// ./clients/SWMH-FP/dictionary.js